import React, { useState, useRef } from 'react';
import './RightPanelTools.css';
import Toolbar from './Toolbar';
import FileActions from './FileActions';
import BrushSlider from './BrushSlider';
import OnClickOutside from './OnClickOutside';

const RightPanelTools = ({
  toolbarRef,
  color,
  setColor,
  toolType,
  setToolType,
  brushsize,
  setBrushsize,
  hotkeyPressed,
  setHotkeyPressed,
  downloadImage,
  printImage,
  newPage,
  importImage,
}) => {
  const [showBrushSlider, setShowBrushSlider] = useState(false);
  const [brushSliderTop, setBrushSliderTop] = useState(0);

  const onOpenBrushSlider = (shouldOpen, top) => {
    setShowBrushSlider(shouldOpen);
    setBrushSliderTop(top);
  };

  const rightPanelWrapperRef = useRef();
  OnClickOutside(rightPanelWrapperRef, () => setShowBrushSlider(false));

  return (
    <div className="right-panel-wrapper" ref={rightPanelWrapperRef}>
      <div className="right-panel">
        <Toolbar
          toolbarRef={toolbarRef}
          color={color}
          setColor={setColor}
          toolType={toolType}
          setToolType={setToolType}
          brushsize={brushsize}
          setBrushsize={setBrushsize}
          hotkeyPressed={hotkeyPressed}
          setHotkeyPressed={setHotkeyPressed}
          onOpenBrushSlider={onOpenBrushSlider}
        />
        <FileActions
          hotkeyPressed={hotkeyPressed}
          setHotkeyPressed={setHotkeyPressed}
          downloadImage={downloadImage}
          printImage={printImage}
          newPage={newPage}
          importImage={importImage}
        />
      </div>
      {showBrushSlider && (
        <BrushSlider
          brushsize={brushsize}
          setBrushsize={setBrushsize}
          color={color}
          toolType={toolType}
          top={brushSliderTop}
        />
      )}
    </div>
  );
};

export default RightPanelTools;
